import { Result, Button } from "antd";
import React from "react";
import { withTranslation } from "react-i18next";
import { ROUTER_PATH } from "../../common/constant";
import { IPageNotFoundProps } from "../../models/interface/IPageNotFoundProps";
import { localizeRouteKey } from "../../shared/helpers";
import './style.scss'

const PageNotFound = ({ t, history }: IPageNotFoundProps) => {

    return <div className={"kd-page-not-found"}>
        <Result
            status="404"
            title="404"
            subTitle={t("404_sub_title")}
            extra={<Button type="primary" onClick={() => history.replace(localizeRouteKey(ROUTER_PATH.HOME))}>{t("back_to_home")}</Button>}
        />
    </div>
}

export default withTranslation()(PageNotFound);